export default {
  newDesign: true,
  title: "Bezpłatny kurs tworzenia gier ROBLOX | Kodland",
  downtimeUrl: "https://www.kodland.org/pl",
  parameters: {
    landing_id: "PlRobFC",
    segment: 7,
  },
  startPage: {
    title:
      "Odpowiedz na pytania i uzyskaj dostęp do BEZPŁATNEGO KURSU!",
    subtitle:
      "Twoje dziecko nauczy się tworzyć gry w Roblox, a nie tylko w nie grać. Oferujemy interesujące i produktywne zajęcia.",
    image: {
      url: "/welcome/pl_rob_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/pl_rob_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Zapisz się na kurs 🚀 ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Dziękujemy za zaufanie naszej platformie edukacyjnej!",
    subtitle:
      "Niestety, tablety lub telefony nie nadają się do korzystania z naszych lekcji. Będziemy szczęśliwi, widząc Was na naszych zajęciach następnym razem!",
  },
  quizRotateBySteps: {
    1: {
      title: "Ile lat ma Twoje dziecko? 🎂",
      type: "age",
      button: "",
    },
    2: {
      question: "Czy Twoje dziecko lubi grać w gry wideo, takie jak Roblox lub Minecraft?",
      answers: [
        "Tak, uwielbia je! 🎮",
        "Ale nie często 🤔",
        "Czasami 🤷‍♂️"
      ],
    },
    3: {
      question: "Czy Twoje dziecko wykazuje zainteresowanie tworzeniem postaci, historii lub światów?",
      answers: [
        "Tak, ma bardzo rozwiniętą wyobraźnię ✨",
        "Nie za bardzo, woli inne zajęcia 🎮",
        "Trochę, ale potrzebuje wskazówek 🤔"
      ],
    },
    4: {
      question: "Czy Twoje dziecko lubi rozwiązywać zagadki lub rozumieć, jak działają gry?",
      subtitle: "To pomoże nam odpowiednio dobrać wykwalifikowanego nauczyciela pod charakter Twojego dziecka",
      answers: [
        "Tak, lubi wyzwania i łamigłówki 🧩",
        "Nie, woli prostsze gry 🎮",
        "Czasami, jeśli jest to część gry 🧐"
      ],
    },
    5: {
      question: "Jak Twoje dziecko spędza większość wolnego czasu?",
      answers: [
        "Kreatywne czynności 🎨",
        "Oglądając YouTube 📺",
        "Zajęcia na świeżym powietrzu ⚽",
      ],
    },
    6: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/quiz_br_2.webp",
      subtitle: "Oferujemy zarówno indywidualny, jak i grupowy format nauki, a także bierzemy pod uwagę wiek dzieci, aby jak najlepiej dostosować proces do każdego dziecka.",
      button: "Zaczynajmy!",
    },
    7: {
      question:
        "Czy masz dostęp do komputera/laptopa?",
      answers: [
        "Tak 💻",
        {
          answer: "Nie 🚫",
          stopAnswer: true,
        },
      ],
    },
    8: {
      title: "Gratulacje!",
      typeInfo: "congrats",
      subtitle:
        "W Kodland uczniowie tworzą 3D modele, komiksy, gry i programy. Obecnie 30 000 dzieci uczy się z nami!",
      button: "Prawie skończyliśmy 🎉",
    },
    9: {
      title: "Uzupełnij dane kontaktowe, aby uzyskać dostęp do darmowego kursu",
      type: "one-page-contacts",
      subtitle: "",
      button: "Prawie skończone 🔥",
    },
    10: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    11: {
      title: "Przejrzyj te informacje, aby zakończyć rejestrację ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Pamiętaj, że do lekcji będziesz potrzebować działającego komputera stacjonarnego lub laptopa i musisz towarzyszyć swojemu dziecku przez cały czas trwania zajęć. Pamiętaj, że zajęcia są indywidualne i spersonalizowane.",
      button: "Co jeszcze?",
    },
    12: {
      title:
        "Przed zajęciami próbnymi sprawdź swoją skrzynkę e-mail i WhatsApp 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Na 24 godziny przed zajęciami wyślemy przypomnienie, a na 2 godziny przed zajęciami poprosimy o potwierdzenie obecności. Bardzo ważne jest, abyśmy pozostali w kontakcie, aby zajęcia nie zostały odwołane.",
      button: "Co jeszcze?",
    },
    13: {
      title: "Lekcja odbędzie się na naszej platformie 💻",
      typeInfo: "classroom",
      subtitle:
        "Otrzymasz link i unikalny kod przez WhatsApp oraz e-mail. Wystarczy kliknąć w link, a przeniesie Cię on prosto do lekcji. Bez dodatkowych aplikacji, bez pobierania.",
      button: "Rozumiem ✅",
    },
  },
};
